module.exports = __webpack_public_path__ + "img/trissen2.2e73e6f6.png";